import { useMemo, useState } from 'react';

const dropdownStyle = {
  position: 'absolute',
  top: '100%',
  left: 0,
  right: 0,
  zIndex: 1050,
  background: '#fff',
  border: '1px solid #dee2e6',
  borderRadius: '4px',
  maxHeight: '200px',
  overflowY: 'auto',
  listStyle: 'none',
  margin: '2px 0 0',
  padding: 0,
  boxShadow: '0 4px 8px rgba(0,0,0,0.12)',
};

/**
 * Generic autocomplete text input for address fields (suburb, postcode, etc).
 * Library-agnostic: onChange always receives the plain string value, so it can be
 * wired into react-hook-form, Formik, or plain useState.
 */
function AddressAutocompleteInput({ name, value, onChange, onBlur, inputRef, options, onValueChange, placeholder, className }) {
  const [open, setOpen] = useState(false);
  const [hovered, setHovered] = useState(null);

  const filtered = useMemo(() => {
    const val = (value || '').toUpperCase();
    if (!val) return [];
    return options.filter(o => o.startsWith(val)).slice(0, 50);
  }, [options, value]);

  const handleBlur = (e) => {
    setTimeout(() => { setOpen(false); setHovered(null); }, 150);
    if (onBlur) onBlur(e);
  };

  const handleInputChange = (e) => {
    onChange(e.target.value);
    setOpen(true);
    if (onValueChange) onValueChange(e.target.value);
  };

  const handleSelect = (opt) => {
    onChange(opt);
    setOpen(false);
    setHovered(null);
    if (onValueChange) onValueChange(opt);
  };

  return (
    <div style={{ position: 'relative' }}>
      <input
        ref={inputRef}
        name={name}
        value={value}
        onChange={handleInputChange}
        onBlur={handleBlur}
        onFocus={() => setOpen(true)}
        placeholder={placeholder}
        type="text"
        autoComplete="off"
        className={className}
      />
      {open && filtered.length > 0 && (
        <ul style={dropdownStyle}>
          {filtered.map(opt => (
            <li
              key={opt}
              onMouseDown={() => handleSelect(opt)}
              onMouseEnter={() => setHovered(opt)}
              onMouseLeave={() => setHovered(null)}
              style={{ padding: '6px 12px', cursor: 'pointer', fontSize: '0.875rem', background: hovered === opt ? '#f0f0f0' : '' }}
            >
              {opt}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default AddressAutocompleteInput;
